module.exports = __webpack_public_path__ + "static/img/A81.fe443c27.jpg";